import React from 'react';

const LimitReachedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="p-4">
          <h2 className="text-sm font-semibold mb-4">Osiągnięto limit</h2>
          <p className="text-sm text-neutral-700 mb-6">
            Niestety osiągnąłeś maksymalną liczbę list słówek. Aby utworzyć nową listę, musisz najpierw usunąć jedną z istniejących.
          </p>
          
          <div className="flex justify-center">
            <button
              onClick={onClose}
              className="px-3 py-1.5 text-xs font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
            >
              Rozumiem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitReachedModal; 